import { Container, Row } from "reactstrap";
import { HelperClasses, UIKits } from "../../../constants";
import BorderColor from "./BorderColor";
import FontSize from "./FontSize";
import FontStyle from "./FontStyle";
import FontWeight from "./FontWeight";
import ImageSize from "./ImageSize";
import TextColors from "./TextColors";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import BorderStyles from "./borderStyles";
import BordersAndDisplays from "./bordersAndDisplays";
import BackgroundColors from "./backgroundColors";

const HelperClassContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={HelperClasses} parent={UIKits} />
      <Container fluid>
        <Row>
          <BorderStyles />
          <BordersAndDisplays />
          <BackgroundColors />
          <BorderColor />
          <ImageSize />
          <FontStyle />
          <FontWeight />
          <TextColors />
          <FontSize />
        </Row>
      </Container>
    </>
  );
};
export default HelperClassContainer;
